import axios from 'axios'
import { toCamelCase, toSnackCase } from './functions'

let TOKEN = ''

switch (process.env.REACT_APP_RELEASE_ENV) {
    case 'development':
        TOKEN = 'FASXOnXtK4M722I4Ir3xwIJfUzHRudgr'
        break
    case 'production':
        TOKEN = 'FASXOnXtK4M722I4Ir3xwIJfUzHRudgr'
        break
    default:
        TOKEN = 'FASXOnXtK4M722I4Ir3xwIJfUzHRudgr'
        break
}

export const FmWorldController = new AbortController()

const FmWorldAxios = axios.create({
    headers: {
        'Content-Type': 'application/json',
    },
})

FmWorldAxios.interceptors.response.use(
    (response) => {
        response.data = toCamelCase(response.data)
        return response
    },
    async (error) => {
        return Promise.reject(error)
    }
)

FmWorldAxios.interceptors.request.use(
    (config) => {
        config.data = toSnackCase(config.data)
        const token = TOKEN
        if (token && config.headers) {
            config.headers.Authorization = `Bearer ${token}`
        }
        return config
    },
    async (error) => {
        return Promise.reject(error)
    }
)

export default FmWorldAxios
